import { jsx as _jsx } from "react/jsx-runtime";
import { PillsLayout } from './PillsLayout';
import { SubTabLayout } from './SubTabLayout';
import { TabLayout } from './TabLayout';
export const TabGroupLayout = ({ variant, nav, tabs }) => {
    switch (variant) {
        case 'pills':
            return _jsx(PillsLayout, { nav: nav, tabs: tabs });
        case 'subtab':
            return _jsx(SubTabLayout, { nav: nav, tabs: tabs });
        default:
            return _jsx(TabLayout, { nav: nav, tabs: tabs });
    }
};
